import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useThunkDispatch, useTypedSelector } from 'hooks';
import { ChangeEvent, useEffect, useState } from 'react';
import { shouldReload } from 'utils/state.handlers';
import { allZones } from 'redux/actions/zones.actions';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import { RenderIf } from '../Tools/Utils';
import { fetchOffices } from '../../redux/actions/catalog.actions';
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));
export default function FilterDashboard({
  changeZone,
  changeOffice,
}: Readonly<{
  changeZone: (zoneId: number) => void;
  changeOffice: (officeId: number) => void;
}>) {
  const zones = useTypedSelector((z) => z.zones);
  const branchOffices = useTypedSelector((z) => z.catalog.offices);

  const [filterZona, setFilterZona] = useState(0);
  const [filterOffice, setFilterOffice] = useState(0);
  const classes = useStyles();

  const dispatch = useThunkDispatch();

  useEffect(() => {
    if (shouldReload(zones)) {
      dispatch(allZones());
    }
  }, [zones]);

  const getOfficesByZone = (zoneId: number) => {
    if (zoneId !== 0) {
      setFilterOffice(0);
      dispatch(fetchOffices({ ZoneId: zoneId }));
    }
    changeZone(zoneId);
  };

  const handleChangeZone = (event: ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as number;
    setFilterZona(value);
    getOfficesByZone(value);
  };

  const handleChangeOffice = (event: ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as number;
    setFilterOffice(value);
    changeOffice(value);
  };
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <FormControl className={classes.formControl}>
        <InputLabel id="select-label-zona">Zona</InputLabel>
        <Select
          labelId="select-label-zona"
          id="select-zona"
          value={filterZona}
          onChange={handleChangeZone}
        >
          <MenuItem value={0}>Sin Filtrar</MenuItem>
          {zones.zones.map((item) => {
            return (
              <MenuItem value={item.id} key={item.id}>
                {item.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      <RenderIf condition={filterZona > 0}>
        <FormControl className={classes.formControl}>
          <InputLabel id="select-label-sucursal">Sucursal</InputLabel>
          <Select
            labelId="select-label-sucursal"
            id="select-sucursal"
            value={filterOffice}
            onChange={handleChangeOffice}
          >
            <MenuItem value={0}>Sin Filtrar</MenuItem>
            {
            branchOffices.data
            .filter((office) => office.zone.id === filterZona)
            .map((item) => {
              return (
                <MenuItem value={item.id} key={item.id}>
                  {item.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </RenderIf>
    </div>
  );
}
